'use strict';

import { view } from '@/functions';

const prefix = '/global-accounts';
export default [
    {
        path: prefix,
        name: 'global-accounts',
        meta: {
            title: 'Global accounts',
            scopes: ['read_accounts', 'write_accounts']
        },
        component: () => view('global-accounts/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'global-accounts-info',
        meta: {
            title: 'Global accounts',
            scopes: ['read_accounts', 'write_accounts']
        },
        component: () => view('global-accounts/info'),
    },
    {
        path: `${prefix}/notifications`,
        name: 'global-accounts-notifications',
        meta: {
            title: 'Global accounts',
            scopes: ['read_accounts', 'write_accounts']
        },
        component: () => view('global-accounts/notifications'),
    }
];
